// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Materials from 'vue-materials'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueResource from 'vue-resource'
import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import Notifications from 'vue-notification'
import axios from 'axios'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  color: 'rgb(255, 102, 0)',
  failedColor: 'red',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
})

window.http = axios.create({
  // baseURL: 'https://mensajeros.guepardos.co/api/v2/'
  baseURL: 'http://localhost:3005/api/v2/'
})
Vue.use(Notifications)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAXR2_IBAefo-cZesOHbhdpWNPk4V08U7o',
    libraries: 'geometry,places'
  }
})

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)

Vue.use(Materials)
Vue.use(VueResource)
Vue.use(VueLodash, lodash)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js